import * as _ from 'lodash';
import { GetListParams, GetListResult } from 'react-admin';
import { getClientApi } from 'src/data-communication';
import { mapGetOrderListResponseDtoToModel } from 'src/mappers';
import { Order, Quote } from 'src/models';

import { getQuoteList } from './quote.provider';

const clientApi = getClientApi();

export const getOrderList = async (params: GetListParams): Promise<GetListResult<Order>> => {
  const { accountId } = params.meta;

  const { data, total } = await clientApi.orders.list({
    params: {
      accountId,
    },
    queryParams: {
      skip: params.pagination.perPage * (params.pagination.page - 1),
      take: params.pagination.perPage,
    },
  });

  const symbols: string[] = data.reduce((all: string[], current) => {
    if (current.UnderlyingSymbol) {
      all.push(current.UnderlyingSymbol);
    }

    return all;
  }, []);
  let snapQuotes: Quote[] = [];

  try {
    if (!_.isEmpty(symbols)) {
      const response = await getQuoteList({
        meta: {
          symbols,
        },
      });
      snapQuotes = response.data;
    }
  } catch (error) {
    // TODO: replace console logs with logger
    // eslint-disable-next-line no-console
    console.error('Error fetching quote media snap.');
    // eslint-disable-next-line no-console
    console.error(error);
  }

  return {
    data: mapGetOrderListResponseDtoToModel(data, snapQuotes),
    total,
  };
};
